import React from 'react';
import PropTypes from 'prop-types'

import {
  cooperInner as defaultInnerOptions,
  cooperOuter as defaultOuterOptions,
} from 'pu-data/SelectOptions';
import { copperWeight as tooltip } from 'pu-data/Tooltips';
import SelectDualComponent from './base/SelectDualComponent';

const CopperWeight = props => (
  <SelectDualComponent
    {...props}
    defaultOptionsA={props.innerOptions}
    defaultOptionsB={props.outerOptions}
    label={props.label}
    labelTopA={props.labelInner}
    labelTopB={props.labelOuters}
    labelBottomA={props.labelBottomInner}
    labelBottomB={props.labelBottomOuters}
    nameA="copper_inners"
    nameB="copper_outers"
    required={props.required}
    requiredA={props.requiredInner}
    requiredB={props.requiredOuters}
    tooltip={props.tooltip}
    tooltipA={props.tooltipInner}
    tooltipB={props.tooltipOuter}/>
);

CopperWeight.defaultProps = {
  label: 'Copper Weight',
  labelInner: null,
  labelOuters: null,
  labelBottomInner: 'Inner',
  labelBottomOuters: 'Outer',
  requiredInner: false,
  requiredOuters: false,
  innerOptions: defaultInnerOptions,
  outerOptions: defaultOuterOptions,
  tooltip,
  tooltipInner: null,
  tooltipOuter: null,
};

CopperWeight.propTypes = {
  parameters: PropTypes.object.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
}

export default CopperWeight;
